import React from "react";
import Header from "../../components/header/header";
import Herosec from "../../components/herosec/herosec";
import Giftabout from "../../components/about-giftcity/giftabout";
import Gcc from "../../components/GCdirectory/gcc";
import Whatwedo from "../../components/what-we-do/whatwedo";
import Footer from "../../components/footer/footer";
import Information from "../../components/information/information";
import Giftcitysection from "../../components/giftcitysection/giftcitysection";
import Talentinfrastructure from "../../components/TalentInfrastructure/talentinfrastructure";

const Home = () => {
  return (
    <div>
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <Herosec />

      {/* About Gift City Section */}
      <Giftabout />

      {/* GCC Directory Section */}
      <Gcc />

      {/* Gift City Section */}
      <Giftcitysection />

      {/* Information Section */}
      <Information />

      {/* TalentInfrastructure Section */}
      <Talentinfrastructure />

      {/* what we do Section */}
      <Whatwedo />

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default Home;
